<template>
  <div class="swiper coch-wheel">
    <div class="swiper-wrapper">
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle";
import {GetTestMechListIndex, GetUserCoachListIndex} from "@/api/admin/new";

export default {
  name: "",
  data() {
    return {
      dataList: [],
      swiper: null,
      imgPath: window.apiObj.apiUrl,
      coachPaging: {
        limit: 10,
        page: 1
      },
    };
  },
  created() {
    this.creSwiper()
    this.getUserCoachList();
  },
  methods: {
    //图片路径拼接
    getImgUrl(file_path) {
      return file_path ? this.imgPath + file_path : "/image/personal/head_portrait.jpg";
    },
    // 考评员列表
    getUserCoachList() {
      GetUserCoachListIndex(this.coachPaging).then((data) => {
        this.coachPaging.page++
        let list = data.data.result
        if (list) {
          if (list.items.length < this.coachPaging.limit) {
            this.coachPaging.page = 1
          }
          this.swiper.virtual.appendSlide(this.group(list.items, 2));
        }
      })
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
    },
    creSwiper() {
      let _self = this
      this.$nextTick(() => {
        this.swiper = new Swiper(".coch-wheel", {
          direction: 'vertical',
          slidesPerView: 2,
          // loop: true,
          allowTouchMove: false,
          autoplay: {
            delay: 10000,
          },
          on: {
            slideChange: function () {
              if (this.isEnd) {
                _self.getUserCoachList()
              }
            }
          },
          virtual: {
            renderSlide: function (slide, index) {
              return `<div class="swiper-slide">
        <div class="display_wrapper">
          <div class="display_box">
            <img src="${_self.getImgUrl(slide[0].athletes_photo)}" >
            <div class="coch_name">${slide[0].name}(${slide[0].evaluator_rank_name})</div>
          </div>
          <div class="display_box">
            <img src="${_self.getImgUrl(slide[1].athletes_photo)}">
            <div class="coch_name">${slide[1].name}(${slide[1].evaluator_rank_name})</div>
          </div>
        </div>
      </div>`;
            },
            addSlidesAfter: 2,
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.coch-wheel {
  width: 100%;
  height: 100%;
}

/deep/ .display_wrapper {
  display: flex;
  justify-content: space-between;
  height: 100%;

  .display_box {
    flex: 1;
    padding: 0 5px;
  }

  img {
    width: 100%;
    height: 170px;
    border-radius: 10px;
  }

  .coch_name {
    padding: 5px;
    font-size: 14px;
    text-align: center;
  }
}

.display_content {
  text-align: center;
  font-size: 14px;
}
</style>
